var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCardInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.732,
    height: 20.886,
    viewBox: "0 0 30.732 20.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 30.732,
    height: 20.886,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2945",
    "data-name": "Group 2945",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2944",
    "data-name": "Group 2944",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M0,1.806A2.334,2.334,0,0,1,1.742.083,3.463,3.463,0,0,1,2.545,0H28.181A2.357,2.357,0,0,1,30.7,1.826a2.494,2.494,0,0,1,.035.567q0,8.006,0,16.011a2.308,2.308,0,0,1-2.461,2.482h-.15q-12.773,0-25.546,0a2.536,2.536,0,0,1-2.007-.762A2.859,2.859,0,0,1,0,19.082ZM15.356,19.481H28.161c.868,0,1.205-.329,1.205-1.189q0-7.842,0-15.684c0-.871-.33-1.2-1.192-1.2H2.534c-.849,0-1.189.331-1.189,1.173q0,7.857,0,15.714c0,.861.335,1.187,1.206,1.187H15.356",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M37.706,82.058c-.61,0-1.219,0-1.829,0a.757.757,0,0,1-.865-.838q-.012-1.3,0-2.608a.747.747,0,0,1,.815-.832q1.888-.018,3.777,0a.709.709,0,0,1,.773.795q.006,1.349,0,2.7a.711.711,0,0,1-.782.783c-.629.007-1.259,0-1.889,0m-.027-1.413c.35,0,.7,0,1.049,0,.159,0,.244-.054.242-.224q-.006-.51,0-1.019c0-.172-.087-.222-.244-.221-.689,0-1.379.005-2.068,0-.187,0-.244.081-.24.254.007.32.01.64,0,.959-.007.2.089.258.273.254.33-.008.659,0,.989,0",
    transform: "translate(-32.201 -71.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M41.328,205.692q2.652,0,5.3,0c.5,0,.8.262.806.688a.686.686,0,0,1-.632.71,2.344,2.344,0,0,1-.329.011H36.168a1.456,1.456,0,0,1-.475-.044.692.692,0,0,1,.121-1.358,2.682,2.682,0,0,1,.329-.008h5.184",
    transform: "translate(-32.363 -189.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M245.236,48.469q1.723,0,3.446,0c.511,0,.837.278.835.7a.757.757,0,0,1-.844.707q-3.446.005-6.891,0a1.218,1.218,0,0,1-.267-.028.72.72,0,0,1-.581-.732.7.7,0,0,1,.707-.644c.709-.011,1.418,0,2.127,0h1.468",
    transform: "translate(-221.624 -44.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M37.428,169c.469,0,.939,0,1.408,0a.706.706,0,1,1,.024,1.4q-1.468.017-2.936,0a.7.7,0,1,1,.036-1.4c.489-.005.979,0,1.468,0",
    transform: "translate(-32.359 -155.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M111.384,169c.479,0,.958,0,1.437,0a.7.7,0,1,1,.029,1.4q-1.467.02-2.934,0a.706.706,0,1,1,.031-1.4c.479,0,.958,0,1.437,0",
    transform: "translate(-100.407 -155.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M259.475,169c.469,0,.938,0,1.407,0a.707.707,0,1,1,.02,1.405q-1.452.018-2.9,0a.7.7,0,1,1,.01-1.4c.489-.007.978,0,1.467,0",
    transform: "translate(-236.641 -155.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M185.354,170.4c-.479,0-.958.014-1.436,0a.707.707,0,0,1-.688-1.006.658.658,0,0,1,.622-.395c1.017-.007,2.035-.011,3.052,0a.662.662,0,0,1,.672.693.675.675,0,0,1-.7.705c-.508.02-1.017,0-1.526,0h0",
    transform: "translate(-168.48 -155.451)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardInfo);
export default __webpack_public_path__ + "static/media/icon_card_info.25a28d15885010da49a0b113f16bb545.svg";
export { ForwardRef as ReactComponent };